import { SphereTooltip } from "@components/common/sphere-tooltip";
import { useDateTime } from "@hooks/use-date-time";
import { DateTimeUtils } from "@stellar/utils";

interface Props {
  /** The date value to display */
  date: DateTimeUtils.DateTimeInput;
}

/**
 * Renders a date with relative/absolute display and a tooltip showing the full date.
 * Uses relative formatting for recent dates (e.g. "2 days ago") with an absolute tooltip,
 * and absolute formatting for older dates.
 */
export function DateCell({ date }: Props): JSX.Element {
  const { formatDateWithTooltip } = useDateTime();
  const { displayDate, tooltipDate } = formatDateWithTooltip(date);

  return (
    <SphereTooltip
      title={tooltipDate ? <var>{tooltipDate}</var> : ""}
      shouldShowTooltip={Boolean(tooltipDate)}
    >
      <var>{displayDate}</var>
    </SphereTooltip>
  );
}
